import React from 'react';
import { GenericFormPage, GenericDetailPage } from '../../../components/generic';
import { useAccAccountType, AccAccountType } from './useData';
import {
  moduleConfig,
  getDetailSections,
  getInitialFormData,
  mapItemToFormData,
  getStatusBadges,
} from './config';

export { default as List } from './List';

export const Form: React.FC = () => (
  <GenericFormPage<AccAccountType>
    useData={useAccAccountType}
    config={{ ...moduleConfig, getInitialFormData, mapItemToFormData }}
  />
);

export const Detail: React.FC = () => (
  <GenericDetailPage<AccAccountType>
    useData={useAccAccountType}
    config={{ ...moduleConfig, getDetailSections, getStatusBadges }}
  />
);
